import React, { useContext } from 'react'
import AuthLayout from '../../custom/components/templates/AuthLayout'
import '../Login/Login.css'
import * as Yup from 'yup'
import ResetComponent from './resetComponent'
import { Link } from 'react-router-dom'
import { LOGO, SITE_NAME } from '@/utils/'

import SEO from '@/utils/SEO'

const ResetPassword = (props) => {
    const validationArray = Yup.object({
        user_token: Yup.string().required('Required'),
        password: Yup.string()
            .matches(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                'Password must include uppercase and lowercase letters, a number, and a special character.',
            )
            .min(8, 'Minimum 8 Characters')
            .required('Required'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password')], 'passwords not match')
            .required('Required'),
    })

    const initialValues = {
        user_token: props.match.params.token,
        password: '',
        confirm_password: '',
    }

    const resetPasswordData = [
        {
            label: 'New password',
            name: 'password',
            type: 'password',
            placeholder: 'Enter your new password',
            class: 'col-12',
        },
        {
            label: 'Confirm password',
            name: 'confirm_password',
            type: 'password',
            placeholder: 'Re-enter your password',
            class: 'col-12',
        },
    ]

    return (
        <AuthLayout>
            <SEO title="Reset password" url={window.location.href} />
            <div className="auth-top">
                <h2 className="auth-head-title">Reset Password</h2>
                <p className="auth-note">Create a new password</p>
            </div>
            <ResetComponent
                validationArray={validationArray}
                initialValues={initialValues}
                resetPasswordData={resetPasswordData}
                onSuccess={false}
            />
        </AuthLayout>
    )
}
export default ResetPassword
